import React from "react";
import { useStyles } from "./DecisionReview.css";
import Button from "@mui/material/Button";
import { NavLink } from "react-router-dom";
import ReplayIcon from "@mui/icons-material/Replay";
import { FormattedMessage, useIntl } from "react-intl";
import { Step, StepButton, Stepper } from "@mui/material";

const DecisionReviewPointStop = ({
    handleReplayScene,
    handleChangeActiveDecision,
    time,
    sessionInfo,
    feedbackMode,
    decisions,
    activeStep,
    endRun
}) => {
    const classes = useStyles();
    const intl = useIntl();
    console.log(decisions);
    const getRedirectInfo = () => {
        if (sessionInfo.isReplay === false && endRun === false) {
            return {
                pathname: "/game/session",
                state: {
                    playlistName: sessionInfo.playlistName,
                    scoredSceneCount: sessionInfo.scoredSceneCount,
                    courseId: sessionInfo.courseId,
                    playlistId: sessionInfo.playlistId,
                    isReplay: sessionInfo.isReplay,
                    feedbackMode: feedbackMode,
                },
            };
        } else {
            return {
                pathname: "/game/dashboard",
            };
        }
    };
    return (
        <div className={classes.reviewSceneNavContainerPointstop}>
            {feedbackMode === "standard" && (
                <Button
                    className={classes.slowMotionButton}
                    onClick={() => {
                        handleReplayScene(0, time);
                    }}
                >
                    <ReplayIcon style={{ color: "white", fontSize: "35px" }} />
                    <br />
                    <FormattedMessage
                        id={"app.game.buttons.review.replay"}
                        defaultMessage={"Replay Slow Motion"}
                    />
                </Button>
            )}

            {feedbackMode === "standard" && decisions.length === 2 && (
                <div
                    style={{
                        color: "white",
                        float: "left",
                        width: "45%",
                        fontSize: "1vw",
                        marginLeft: "3%",
                        justifyContent: "space-between",
                        display: "flex",
                    }}
                >
                    <div
                        style={{
                            color: "white",
                            float: "left",
                            width: "45%",
                            fontSize: "1.3vw",
                            margin: "auto",
                            justifyContent: "center",
                        }}
                    >
                        Concurrent Decisions:
                    </div>
                    <Stepper
                        nonLinear
                        activeStep={activeStep}
                        className={classes.sceneTimelinePointstop}
                    >
                        {decisions.map((decision, index) => (
                            <Step key={index}>
                                <StepButton
                                    onClick={() => {
                                        handleChangeActiveDecision(index);
                                    }}
                                />
                            </Step>
                        ))}
                    </Stepper>
                </div>
            )}
            {feedbackMode === "lab" && decisions.length === 2 && (
                <Stepper
                    linear
                    activeStep={activeStep}
                    className={classes.sceneTimelinePointstop}
                >
                    {decisions.map((decision, index) => (
                        <Step key={index}>
                            <StepButton />
                        </Step>
                    ))}
                </Stepper>
            )}

            {feedbackMode === "standard" && (
                <NavLink to={"/game/dashboard"}>
                    <Button className={classes.sceneTimelineButton}>
                        <FormattedMessage
                            id={"app.game.buttons.review.break"}
                            defaultMessage={"Take a Break"}
                        />
                    </Button>
                </NavLink>
            )}

            <NavLink to={getRedirectInfo} style={{ textDecoration: "none" }}>
                <Button className={classes.sceneTimelineButton}>
                    <FormattedMessage
                        id={"app.game.buttons.review.next.video"}
                        defaultMessage={"Next Video"}
                    />
                </Button>
            </NavLink>
        </div>
    );
};

export default DecisionReviewPointStop;
